export const sidebarLayout = {
  default: ['{numbers}', '{abc}', '{kana}', '{nextKeyboard}'],
};

export const actionLayout = {
  default: ['{bksp}', '{space}', '{enter}'],
  withCandidates: ['{bksp}', '{nextCandidate}', '{enter}'],
  // Active while composing a multi-segment Mozc conversion. {bksp} stays
  // first and {enter} last to match the other layouts; the prev/next segment
  // pair stays adjacent so the navigation reads as one control.
  segments: ['{bksp}', '{prevSegment}', '{nextSegment}', '{nextCandidate}', '{enter}'],
};
